module.exports = __webpack_public_path__ + "img/9.1.3.590a5298.svg";